import * as React from "react";
import { PropertyDetails } from "../../../core/api/models/project";

interface IFinanceInformationProps {
  templates: any;
  index: number;
  propertyDetails?: PropertyDetails[];
  onRemove: (propertys: PropertyDetails[]) => void;
  onSelect: () => void;
}

const VersionSort: React.FunctionComponent<IFinanceInformationProps> = (
  props
) => {
  const renderDetails = () => {
    return (
      <>
        <div className="border px-3 py-2 mb-2">
          <i
            className="icon-arrange text-gray-400 cursor-pointer"
            style={{ fontSize: "8px" }}
          ></i>
          <span className="font-sm ml-3 font-weight-semibold py-1 d-inline-block">
            V{props.templates} (
            {
              props.propertyDetails?.filter((x) =>
                props.templates === 0
                  ? !x.proposalVersion
                  : x.proposalVersion === props.templates
              )?.length
            }
            )
          </span>
        </div>
      </>
    );
  };

  return <>{renderDetails()}</>;
};

export default VersionSort;
